import type { User } from '@/shared/types/user';

export function getItemsMatchingSearch(items: User[], search: string) {
  if (!search) {
    return items;
  }

  search = search.toLowerCase();
  if (search.indexOf('@') !== -1) {
    return items.filter((item) =>
      item.data.email?.toLowerCase().startsWith(search),
    );
  }

  return items.filter((item) =>
    item.data.displayName.toLowerCase().includes(search),
  );
}

export function makeUser(): User {
  return {
    id: '',
    data: {
      active: false,
      archived: false,
      email: '',
      displayName: '',
    },
  } as User;
}
